export enum BREAKPOINTS {
	PhoneOnly = '@media only screen and (max-width: 37.44em)',
	TabletUp = '@media only screen and (min-width: 37.5em)',
	TabletLandscapeUp = '@media only screen and (min-width: 56.25em)',
	DesktopUp = '@media only screen and (min-width: 75em)',
	BigDesktopUp = '@media only screen and (min-width: 112.5em)'
}
